<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <div>
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <h5>Asigne las evaluaciones de Alumnos a Colaboradores</h5>
                        <button matTooltip="Agregar" class="btn boton botonXS" [class.disabled]="visualizar" (click)="Modal()">
                            <span class="fa fa-plus"></span>
                            <span> {{'Agregar'}}</span>
                        </button>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-12" style="text-align: right;">
                        <h5>Previsualizar evalución colaboradores</h5>
                        <div class="row margen">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                            <dropdownCustom [titulo]="'Seleccionar colaborador'"
                            [opciones]="colaboradores"
                            [(ngModel)]="colaboradorid"
                            [valorName]="'asignacionevaluacionalumnoporcolaboradorid'"
                            [displayValor]="'nombre'"
                            [buscar]="false"
                            (ngModelChange)="getGrado($event)"
                            ></dropdownCustom>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                          <dropdownCustom [titulo]="'Seleccionar grado'"
                          [opciones]="listagrados"
                          [(ngModel)]="gradoid"
                          [displaybackgrountcolor]="'color'"
                          [valorName]="'gradoid'"
                          [displayValor]="'grado'"
                          (ngModelChange)="preevisualizar($event)"
                          [buscar]="false"
                          ></dropdownCustom>
                      </div>
                        </div>
                      </div>
                    </div>
                    <!-- datos -->
                    <div >
                        <dx-data-grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [noDataText]="'Sin Datos'"
                            [dataSource]="Dataalumnocolaborador"
                            [showColumnHeaders]="true"
                            (onInitialized)="onInitialized($event)"
                            (onRowPrepared)="onRowPrepared($event)"
                            >
                            <dxo-paging [pageSize]="0"></dxo-paging>
                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>


                            <dxo-pager
                                [visible]="false"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>
                            <dxi-column
                                dataField="gradoygrupo"
                                [groupIndex]="1"
                                groupCellTemplate="groupCellTemplateGrado"
                                [autoExpandGroup]="false"
                                width="40px">
                            </dxi-column>
                            <dxi-column
                                dataField="colaborador"
                                [groupIndex]="0"
                                groupCellTemplate="groupCellTemplateColaborador"
                                [autoExpandGroup]="false">
                            </dxi-column>
                            <dxi-column
                                dataField="matricula"
                                caption="Matricula"
                                width="100px"
                                alignment="left"
                                >
                            </dxi-column>
                            <dxi-column
                                dataField="alumno"
                                caption="Alumno">
                            </dxi-column>

                            <div *dxTemplate="let cellInfocolaborador of 'groupCellTemplateColaborador'">
                                <div class="accionEncabezado">
                                    <div class="accionEncabezado__titulo">
                                        {{cellInfocolaborador.value}}
                                    </div>
                                    <div class="accionEncabezado__acciones">
                                        <span>{{cellInfocolaborador.data.total}} evaluaciones asignadas</span>
                                        <a matTooltip="Editar" class="tablaBoton separado edit" (click)="Formulario(cellInfocolaborador)" [class.disabled]="visualizar" *ngIf="sistemaService.permisos.editar">
                                            <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                        </a>
                                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cellInfocolaborador)" [class.disabled]="visualizar" *ngIf="sistemaService.permisos.eliminar">
                                            <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div *dxTemplate="let cellInfoGrado of 'groupCellTemplateGrado'">
                                <div class="accionEncabezado">
                                    <div class="accionEncabezado__titulo">
                                        <span class="accionEncabezado__titulo--subgrupo">{{cellInfoGrado.value}}</span>
                                    </div>
                                    <div class="accionEncabezado__acciones" >
                                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="EliminarGrado(cellInfoGrado)" [class.disabled]="visualizar" *ngIf="sistemaService.permisos.eliminar">
                                            <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<colaboradorevaluacionmodal
    #colaborador
    (respuesta)="GuardarColaborador($event)"
    ></colaboradorevaluacionmodal>

<asignacionalumnonmodal *ngIf="cicloid && nivelid"
    #asignacionalumno
    [cicloid]="cicloid"
    [nivelid]="nivelid"
    (respuesta)="GuardarAlumno($event)"
    ></asignacionalumnonmodal>
